var map = {
	"./assets/thewest-digital-hero-cropped.jpg": 653,
	"./assets/thewest-digital-hero-variation-a-cropped.jpg": 446,
	"./assets/thewest-digital-hero-variation-a.jpg": 654,
	"./assets/thewest-digital-hero-variation-b-cropped.jpg": 655,
	"./assets/thewest-digital-hero-variation-b.jpg": 2555,
	"./assets/thewest-digital-hero-variation-black-friday-cropped.jpg": 656,
	"./assets/thewest-digital-hero-variation-black-friday.jpg": 2556,
	"./assets/thewest-digital-hero-variation-experiment2-cropped.jpg": 657,
	"./assets/thewest-digital-hero-variation-experiment2.jpg": 2557,
	"./assets/thewest-digital-hero-variation-vanishing-cousins-cropped.jpg": 658,
	"./assets/thewest-digital-hero-variation-vanishing-cousins.jpg": 2558,
	"./assets/thewest-digital-hero.jpg": 2559
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2554;